import { useEffect } from "react";
import { getInlineHelpStoreValue } from "../store/inlineHelpStore";
import useStoreLoader from "./useStoreLoader";
import { inlineHelpContentAction$, inlineHelpContentStore$ } from "../store/inlineHelpContentStore";
function useInlineHelpContentActions() {
    var pageId = getInlineHelpStoreValue().pageId;
    var isLoading = useStoreLoader(inlineHelpContentAction$, inlineHelpContentStore$).isLoading;
    useEffect(function() {
        inlineHelpContentAction$.next({
            pageId: pageId
        });
    }, [
        pageId
    ]);
    return {
        isLoading: isLoading
    };
}
export default useInlineHelpContentActions;

//# sourceMappingURL=useInlineHelpContentActions.js.map